import { Modal, Button, Form, InputGroup, Spinner } from "react-bootstrap";
import { useState, useEffect } from "react";
// @ts-ignore
import ReactSlider from "react-slider";
import "../../../scss/products.scss";
import Tick from "../../../assets/tick.png";
import UnTick from "../../../assets/untick.png";
import Switch from "react-switch";
import { MultiSelect } from "react-multi-select-component";

interface FilterModalProps {
  show: boolean;
  onHide: () => any;
  pageProps: any;
  allCategories: { label: string, value: string }[],
  filterValues: {
    productNames: string;
    category: Array<string>;
    status: string;
    minPrice: string;
    maxPrice: string;
    lowStockOnly: boolean;
  };
  setFilterValues: (vals: any) => void;
  onSearch: (filters: {
    productNames: string;
    category: Array<string>;
    status: string;
    minPrice: number;
    maxPrice: number;
    lowStockOnly: boolean;
  }) => void;
  onExport: () => void;
  onReset: () => void;
}

const statusOptions = [
  { label: "All", value: "All" },
  { label: "Active", value: "Active" },
  { label: "Inactive", value: "Inactive" },
];


const FilterModal = ({
  show,
  onHide,
  pageProps,
  filterValues,
  setFilterValues,
  onSearch,
  onExport,
  onReset,
  allCategories
}: FilterModalProps) => {
  const [allCatsSelected, setAllCatsSelected] = useState<any[]>([]);

  const parsedMin = parseFloat(filterValues.minPrice);
  const parsedMax = parseFloat(filterValues.maxPrice);

  const handleSliderChange = ([min, max]: number[]) => {
    setFilterValues({
      ...filterValues,
      minPrice: String(min),
      maxPrice: String(max),
    });
  };

  const handleSearch = () => {
    const selectedCategories = allCatsSelected.map((cat: any) => cat.value);
    onSearch({
      productNames: filterValues.productNames,
      category: selectedCategories,
      status: filterValues.status,
      minPrice: isNaN(parsedMin) ? 0 : parsedMin,
      maxPrice: isNaN(parsedMax) ? 1000 : parsedMax,
      lowStockOnly: filterValues.lowStockOnly,
    });

    onHide();
  };

  useEffect(() => {
    let catFormated: any[] = filterValues.category.map((each: any) => {
      return { label: each, value: each };
    });
    setAllCatsSelected(catFormated)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      dialogClassName="product-filter-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Product filter</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Control
            className="filter-search-input"
            placeholder="Product 1, Product 2, Product 3, ..."
            value={filterValues.productNames}
            onChange={(e) =>
              setFilterValues({ ...filterValues, productNames: e.target.value })
            }
          />
        </Form.Group>

        <div className="d-flex gap-3 mb-3 category-status-wrapper">
          <div className="flex-grow-1 category ">
            <label>Category</label>
            {pageProps.getProductMetaDataRequest.request_status ===
              "GET_PRODUCT_META_PENDING" ? (
              <div className="d-flex align-items-center gap-2 py-2">
                <Spinner animation="border" role="status" size="sm" />
                <span>Loading categories...</span>
              </div>
            ) : (
              <MultiSelect
                options={allCategories}
                value={allCatsSelected}
                onChange={setAllCatsSelected}
                labelledBy="Select"
                hasSelectAll={false}
                className="cat-select-wrap status"
                valueRenderer={(selected) => {
                  if (selected.length === 0) return "All";
                  const visible = selected
                    .slice(0, 2)
                    .map((s) => s.label)
                    .join(", ");
                  const extra =
                    selected.length > 2 ? `, +${selected.length - 2} more` : "";
                  return visible + extra;
                }}
              />
            )}
            {/* </div> */}
          </div>
          <div className="flex-grow-1 status-select-wrap">
            <Form.Group controlId="statusSelect">
              <Form.Label className="mb-1">Status</Form.Label>
              <Form.Select
                className="form-select-lg-min"
                aria-label="Filter by status"
                value={filterValues.status}
                onChange={(e) =>
                  setFilterValues({ ...filterValues, status: e.target.value })
                }
              >
                {statusOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </div>
        </div>

        <div className="price-range mb-3">
          <Form.Label className="mb-1">Price</Form.Label>
          <div className="d-flex justify-content-between mb-2">
            <InputGroup style={{ width: 120 }}>
              <InputGroup.Text>$</InputGroup.Text>
              <Form.Control
                size="sm"
                type="text"
                value={filterValues.minPrice}
                onChange={(e) =>
                  setFilterValues({ ...filterValues, minPrice: e.target.value })
                }
                placeholder="Min"
              />
            </InputGroup>
            <InputGroup style={{ width: 120 }}>
              <InputGroup.Text>$</InputGroup.Text>
              <Form.Control
                size="sm"
                type="text"
                value={filterValues.maxPrice}
                onChange={(e) =>
                  setFilterValues({ ...filterValues, maxPrice: e.target.value })
                }
                placeholder="Max"
              />
            </InputGroup>
          </div>

          <div className="mb-3">
            <ReactSlider
              className="price-slider"
              thumbClassName="price-thumb"
              renderTrack={(props: any, state: any) => {
                const trackClass =
                  state.index === 1
                    ? "price-track price-track-active"
                    : "price-track";
                return <div {...props} className={trackClass} />;
              }}
              value={[
                isNaN(parsedMin) ? 0 : parsedMin,
                isNaN(parsedMax) ? 1000 : parsedMax,
              ]}
              min={0}
              max={1000}
              step={0.01}
              onChange={handleSliderChange}
            />
          </div>
        </div>

        <div className="low-stock-toggle mb-3">
          <span className="low-stock-label">Low stock items</span>
          <Switch
            checkedIcon={true}
            checkedHandleIcon={<img className="tick_img" src={Tick} alt="" />}
            uncheckedHandleIcon={
              <img className="un_tick_img" src={UnTick} alt="" />
            }
            uncheckedIcon={true}
            width={40}
            height={20}
            onHandleColor="#FFFFFF"
            onColor="#00A85B"
            offHandleColor="#9B9B9B"
            offColor="#D8D8D8"
            onChange={(e) =>
              setFilterValues({
                ...filterValues,
                lowStockOnly: !filterValues.lowStockOnly,
              })
            }
            checked={filterValues.lowStockOnly}
          />
        </div>
      </Modal.Body>

      <Modal.Footer className="justify-content-center">
        <Button className="search-btn" onClick={handleSearch}>
          SEARCH
        </Button>
        <Button variant="outline-success" onClick={onReset}>
          RESET
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default FilterModal;